const addresses = [
  {
    id: '1',
    region: 'UKIMEA',
    address: 'Level-1 Tower D,	Bangalore, /, 560 016,	India',
  },
  {
    id: '2',
    region: 'UKIMEA',
    address: 'Ananth Info Park,	Hyderabad,	Telangana,	500 081,	India',
  },
  {
    id: '3',
    region: 'UKIMEA',
    address: 'Suren Road,	Mumbai,	/,400 093,	India',
  },
  {
    id: '4',
    region: 'UKIMEA',
    address: 'Bagatelle Office Park, Bagatelle, /, /, Mauritius',
  },
  {
    id: '5',
    region: 'UKIMEA',
    address: 'V&A Waterfront, Cape Town, /, 8002, South Africa',
  },
  {
    id: '6',
    region: 'UKIMEA',
    address: '167 Florida Road, Durban, /, 4001, South Africa',
  },
  {
    id: '7',
    region: 'UKIMEA',
    address: '10 High Street, Johannesburg, /, 2076,South Africa',
  },
  {
    id: '8',
    region: 'UKIMEA',
    address:
      '12th Floor Abu Dhabi University Tower Al Muroor Street, Abu Dhabi, /, /, United Arab Emirates',
  },
  {
    id: '9',
    region: 'UKIMEA',
    address: '39th Floor Media One Tower, Dubai, /, /, United Arab Emirates',
  },
  {
    id: '10',
    region: 'UKIMEA',
    address: '16-22 Bedford Street, Belfast, /, BT2 7FD, United Kingdom',
  },
  {
    id: '11',
    region: 'UKIMEA',
    address: '63 St Thomas Street, Bristol, /, BS1 6JZ, United Kingdom',
  },
  {
    id: '12',
    region: 'UKIMEA',
    address: '4 Pierhead Street,	Cardiff, /, CF10 4QP, United Kingdom',
  },
  {
    id: '13',
    region: 'UKIMEA',
    address:
      'South Queensferry,	Edinburgh, West Lothian, EH30 9SE, United Kingdom',
  },
  {
    id: '14',
    region: 'UKIMEA',
    address: '1 West Regent Street,	Glasgow, /, G2 1RW, United Kingdom',
  },
  {
    id: '15',
    region: 'UKIMEA',
    address: 'Rose Wharf, Leeds, /, LS9 8EE,United Kingdom',
  },
  {
    id: '16',
    region: 'UKIMEA',
    address: '100 Old Hall Street,	Liverpool, /, L3 9QJ, United Kingdom',
  },
  {
    id: '17',
    region: 'UKIMEA',
    address: '8 Fitzroy Street, London, /, W1T 4BJ, United Kingdom',
  },
  {
    id: '18',
    region: 'UKIMEA',
    address: 'Three Piccadilly Place, Manchester, /, M1 3BN, United Kingdom',
  },
  {
    id: '19',
    region: 'UKIMEA',
    address:
      'Blythe Gate	Midlands, Campus,	West Midlands, B90 8AE, United Kingdom',
  },
  {
    id: '20',
    region: 'UKIMEA',
    address: 'Forth Street,	Newcastle, /, NE1 3PL, United Kingdom',
  },
  {
    id: '21',
    region: 'UKIMEA',
    address: 'City Gate West, Nottingham, /, NG1 5AT, United Kingdom',
  },
  {
    id: '22',
    region: 'UKIMEA',
    address: '3 St Paul’s Place,	Sheffield, /, S1 2JE, United Kingdom',
  },
  {
    id: '23',
    region: 'UKIMEA',
    address: '44 Irish Street,	Whitehaven, /, CA28 7BY, United Kingdom',
  },
  {
    id: '24',
    region: 'UKIMEA',
    address:
      '8 St Thomas Street, Winchester, Hampshire, SO23 9HE, United Kingdom',
  },
  {
    id: '25',
    region: 'EUROPE',
    address: 'Axeltorv 2K 3rd Floor,	Copenhagen, /, 1609,	Denmark',
  },
  {
    id: '26',
    region: 'EUROPE',
    address: 'Joachimstaler Straße 41,	Berlin, /, 10623,	Germany',
  },
  {
    id: '27',
    region: 'EUROPE',
    address: 'Speditionstraße 9,	Düsseldorf, /, 40221,	Germany',
  },
  {
    id: '28',
    region: 'EUROPE',
    address: 'Mayfarthstraße 15,	Frankfurt, /,	60314,	Germany',
  },
  {
    id: '29',
    region: 'EUROPE',
    address: 'One Albert Quay,	Cork, /, T12 X8N6, Ireland',
  },
  {
    id: '30',
    region: 'EUROPE',
    address: '50 Ringsend Road,	Dublin, /, D04 T6X0,	Ireland',
  },
  {
    id: '31',
    region: 'EUROPE',
    address: 'City East Business Park, Galway, /, H91 K5YD, Ireland',
  },
  {
    id: '32',
    region: 'EUROPE',
    address: 'Upper Hartstonge St,	Limerick, /, V94 F8XE, Ireland',
  },
  {
    id: '33',
    region: 'EUROPE',
    address: 'Naritaweg 118,	Amsterdam, /,1043 CA,	Netherlands',
  },
  {
    id: '34',
    region: 'EUROPE',
    address: 'Corso Italia 1,	Milan, /,	20122,	Italy',
  },
  {
    id: '82',
    region: 'EUROPE',
    address: '56 Przybyszewskiego Street,	Krakow, /, 30-128,	Poland',
  },
  {
    id: '83',
    region: 'EUROPE',
    address: '4 Inflancka Street, Warsaw, /, 00-189, Poland',
  },
  {
    id: '35',
    region: 'EUROPE',
    address: '36 Krasnoproletarskaya Street,	Moscow, /, 127473, Russia',
  },
  {
    id: '36',
    region: 'EUROPE',
    address: 'Kneginje Zorke 77,	Belgrade, /, 11000, Serbia',
  },
  {
    id: '37',
    region: 'EUROPE',
    address: 'Alfonso XI 12, Madrid, /, 28014, Spain',
  },
  {
    id: '38',
    region: 'EUROPE',
    address: 'Nihat Erim Is Merkezi 37/13 & 18,	Ankara, /, 06550,	Turkey',
  },
  {
    id: '39',
    region: 'EUROPE',
    address:
      'Nispetiye Mah. Başlık Sok. No:3 Kat:1 34340, Istanbul, /, /, Turkey',
  },
  {
    id: '40',
    region: 'EAST_ASIA',
    address: 'No 66 Preah Monivong, Boulevard,	Phnom Penh, /, Cambodia',
  },
  {
    id: '41',
    region: 'EAST_ASIA',
    address: '2-10-2 Fujimi, Tokyo, /, 102-0071, Japan',
  },
  {
    id: '42',
    region: 'EAST_ASIA',
    address: 'Jing Guang Centre Room 3008 30/F,	Beijing, /, 100020,	China',
  },
  {
    id: '43',
    region: 'EAST_ASIA',
    address: '28 Minquan Road,	Chongqing, /, 400010, China',
  },
  {
    id: '44',
    region: 'EAST_ASIA',
    address: '161 Linhexi Road,	Guangzhou, Guangdong, 510620, China',
  },
  {
    id: '45',
    region: 'EAST_ASIA',
    address: '80 Tat Chee Avenue,	Hong Kong, /, /, Hong Kong',
  },
  {
    id: '46',
    region: 'EAST_ASIA',
    address: 'Avenida Dr. Mário Soares, Macau, /, /, Macau',
  },
  {
    id: '47',
    region: 'EAST_ASIA',
    address:
      '39/F-41/F Huaihai Plaza 1045 Huaihai Middle Road,	Shanghai, /, 200031, China',
  },
  {
    id: '48',
    region: 'EAST_ASIA',
    address:
      '6/F Duty Free Building 6 Fuhua Yi Road, Shenzhen,	Guangdong, 518048, China',
  },
  {
    id: '49',
    region: 'EAST_ASIA',
    address: '3/F, No. 65 Section 2  Tun-Hua South Road, Taipei, /,	106,	Taiwan',
  },
  {
    id: '50',
    region: 'EAST_ASIA',
    address:
      'Room 2215 22/F Tower 1 New World International Trade Centre,	Wuhan,	Hubei,	430022,	China',
  },
  {
    id: '51',
    region: 'EAST_ASIA',
    address:
      '4th Floor Tower 1 Rockwell Business Centre,	Manila, /, 1604,	Philippines',
  },
  {
    id: '52',
    region: 'EAST_ASIA',
    address: '772, Samseong-ro,	Seoul, /, 06070, South Korea',
  },
  {
    id: '53',
    region: 'EAST_ASIA',
    address: '2034/134 New Petchburi, Road	Bangkok, /, 10320,	Thailand',
  },
  {
    id: '54',
    region: 'AUSTRALASIA',
    address: '182 Victoria Square,	Adelaide, /, SA 5000,	Australia',
  },
  {
    id: '55',
    region: 'AUSTRALASIA',
    address: '15 Lake Street,	Cairns, /, QLD 4870, Australia',
  },
  {
    id: '56',
    region: 'AUSTRALASIA',
    address: '10 Moore Street, Canberra, /, ACT 2601, Australia',
  },
  {
    id: '57',
    region: 'AUSTRALASIA',
    address: '108 Wickham Street, Brisbane, /, QLD 4006, Australia',
  },
  {
    id: '58',
    region: 'AUSTRALASIA',
    address: '/, Canberra P.O.Box, /, ACT 2600, Australia',
  },
  {
    id: '59',
    region: 'AUSTRALASIA',
    address: '699 Collins Street,	Melbourne, /, VIC 3008, Australia',
  },
  {
    id: '60',
    region: 'AUSTRALASIA',
    address: '2 The Esplanade, Perth, /,	WA 6000,	Australia',
  },
  {
    id: '61',
    region: 'AUSTRALASIA',
    address: 'St Georges Terrace, Perth P.O.Box, /, WA 6000,	Australia',
  },
  {
    id: '62',
    region: 'AUSTRALASIA',
    address: '151 Clarence Street, Sydney, /,	NSW 2000, Australia',
  },
  {
    id: '63',
    region: 'AUSTRALASIA',
    address: '61-73 Sturt Street, Townsville, /, QLD 4810, Australia',
  },
  {
    id: '64',
    region: 'AUSTRALASIA',
    address: 'Jl. Jend. Sudirman Kav. 86, Jakarta, /,	10220,	Indonesia',
  },
  {
    id: '65',
    region: 'AUSTRALASIA',
    address: 'No 20 Jalan 7A/62A,	Kuala Lumpur, /, 52200, Malaysia',
  },
  {
    id: '66',
    region: 'AUSTRALASIA',
    address: 'Lots L6.01 to L6.09, Penang, /, 10250,	Malaysia',
  },
  {
    id: '67',
    region: 'AUSTRALASIA',
    address: '205-209 Queen Street, Auckland, /, /, New Zealand',
  },
  {
    id: '68',
    region: 'AUSTRALASIA',
    address: '182 Cecil Street, Singapore, /, 069547, Singapore',
  },
  {
    id: '69',
    region: 'AMERICAS',
    address: '1 Place Ville Marie,	Montréal,	Québec,	H3B 3Y2, Canada',
  },
  {
    id: '70',
    region: 'AMERICAS',
    address: '121 Bloor Street East,	Toronto, /, M4W 3M5, Canada',
  },
  {
    id: '71',
    region: 'AMERICAS',
    address: 'Torre 2 Piso 7,	Bogotá, /, /, Colombia',
  },
  {
    id: '72',
    region: 'AMERICAS',
    address: '60 State Street,	Boston, /, MA 02109, USA',
  },
  {
    id: '73',
    region: 'AMERICAS',
    address: '35 East Wacker Drive, Chicago, /, IL 60601, USA',
  },
  {
    id: '74',
    region: 'AMERICAS',
    address: '750 N. St. Paul Street, Dallas, /, TX 75201, USA',
  },
  {
    id: '75',
    region: 'AMERICAS',
    address: '10370 Richmond Avenue,	Houston, /, TX 77042, USA',
  },
  {
    id: '76',
    region: 'AMERICAS',
    address: '900 Wilshire Boulevard, Los Angeles, /, CA 90017, USA',
  },
  {
    id: '77',
    region: 'AMERICAS',
    address: '499 Thornall Street, New Jersey, /, NY 08837, USA',
  },
  {
    id: '78',
    region: 'AMERICAS',
    address: '77 Water Street, New York, /, NY 10005, USA',
  },
  {
    id: '79',
    region: 'AMERICAS',
    address: '1330 Broadway, Oakland, /, CA 94612, USA',
  },
  {
    id: '80',
    region: 'AMERICAS',
    address: '560 Mission Street,   San Francisco, /, CA 94105, USA',
  },
  {
    id: '81',
    region: 'AMERICAS',
    address: '1191 Second Avenue, Seattle, /, WA 98101, USA',
  },
];
export default addresses;
